import isoUrl from "@/assets/dravian-iso.svg";
import wordmarkUrl from "@/assets/dravian-wordmark.svg";

export function DravianLogo({ className }: { className?: string }) {
  return (
    <div className={`flex items-center gap-3 ${className ?? ""}`}>
      <img src={isoUrl} alt="" className="h-8 w-auto invert" />
      <div className="flex flex-col gap-[5px]">
        <img src={wordmarkUrl} alt="DRAVIAN" className="h-[9px] w-auto" />
        <div className="text-[10px] leading-none font-medium tracking-[0.32em] text-muted-foreground">HORIZON</div>
      </div>
    </div>
  );
}

export function DravianMark({ className }: { className?: string }) {
  return <img src={isoUrl} alt="Dravian" className={`invert ${className ?? ""}`} />;
}
